import { Routes, Route } from "react-router";
import { AudioProvider } from "@/components/audio-provider";
import { Soundboard } from "@/pages/Soundboard";
import { SoundPermalink } from "@/pages/SoundPermalink";
import { ComboPermalink } from "@/pages/ComboPermalink";
import { BoardMode } from "@/pages/BoardMode";
import { TriggerMode } from "@/pages/TriggerMode";
import { AdminLayout } from "@/pages/admin/AdminLayout";
import { AdminDashboard } from "@/pages/admin/AdminDashboard";
import { AdminUpload } from "@/pages/admin/AdminUpload";
import { AdminSounds } from "@/pages/admin/AdminSounds";
import { AdminCombos } from "@/pages/admin/AdminCombos";
import { AdminAnalytics } from "@/pages/admin/AdminAnalytics";
import { AdminBoards } from "@/pages/admin/AdminBoards";
import { AdminAuditLog } from "@/pages/admin/AdminAuditLog";
import { AdminWebhooks } from "@/pages/admin/AdminWebhooks";
import { AdminBackups } from "@/pages/admin/AdminBackups";
import { AdminMaintenance } from "@/pages/admin/AdminMaintenance";
import { AdminSettings } from "@/pages/admin/AdminSettings";
import { Styleguide } from "@/pages/Styleguide";

const showStyleguide = import.meta.env.VITE_SHOW_STYLEGUIDE === "1";

export function App() {
  return (
    <AudioProvider>
      <Routes>
        <Route path="/" element={<Soundboard />} />
        <Route path="/s/:slug" element={<SoundPermalink />} />
        <Route path="/c/:slug" element={<ComboPermalink />} />
        <Route path="/board" element={<BoardMode />} />
        <Route path="/trigger/:slug" element={<TriggerMode />} />
        {showStyleguide && (
          <Route path="/styleguide" element={<Styleguide />} />
        )}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="upload" element={<AdminUpload />} />
          <Route path="sounds" element={<AdminSounds />} />
          <Route path="combos" element={<AdminCombos />} />
          <Route path="boards" element={<AdminBoards />} />
          <Route path="analytics" element={<AdminAnalytics />} />
          <Route path="audit" element={<AdminAuditLog />} />
          <Route path="webhooks" element={<AdminWebhooks />} />
          <Route path="backups" element={<AdminBackups />} />
          <Route path="maintenance" element={<AdminMaintenance />} />
          <Route path="settings" element={<AdminSettings />} />
        </Route>
      </Routes>
    </AudioProvider>
  );
}
